import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeDatasets } from '../actions';
import DatasetsActions from '../containers/DatasetsActions';
import DatasetsPanel from '../components/DatasetsPanel';

export default {
  ...tabTemplate('datasets', DatasetsPanel, matchSingleUrl(['datasets']), DatasetsActions),
  ...tabCloser('closeDatasetsTab', closeDatasets),
  ...tabIcons('database'),
  access: ({ datasets }) => datasets.read,
  componentState: ({ url }) => categoryTab(url, 'all'),
  order: 200,
  position: 'top-right',
};
